import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import SelectCurrency from 'commons/components/SelectCurrency';
import ButtonWithLoader from 'commons/containers/ButtonWithLoader';
import { formatDateSlash } from 'utils/dateHelpers';
import { ZCOR_START } from '../../reducer';

const describeZcorBase = (zcorBase) => {
  if (!zcorBase) return 'ZCOT vigente (al guardar se crea una versión nueva)';
  const base =
    zcorBase.mode === ZCOR_START.EDIT
      ? `Editando ${zcorBase.versionLabel}`
      : `Nueva versión a partir de ${zcorBase.versionLabel}`;
  return zcorBase.formulaChanged
    ? `${base}. La fórmula cambió desde esa versión: revise los ZCOR unit.`
    : base;
};

const CardCustomItem = React.memo((itemProps) => (
  <Grid item xs={12} mb="10px">
    <Grid container justifyContent="space-between">
      <Grid item xs={3}>
        <Typography>{itemProps.label}:</Typography>
      </Grid>
      <Grid item xs={9}>
        <Typography>{itemProps.value}</Typography>
      </Grid>
    </Grid>
  </Grid>
));

const FormulaResultsCard = function (props) {
  const { controls, currencyCode, setCurrencyCode, onSaveZcor } = props;
  const { latestZcorVersion, zcorBase } = controls;
  const isEditing = zcorBase?.mode === ZCOR_START.EDIT;
  return (
    <Grid container mb="20px" justifyContent="space-between" alignItems="center">
      <Card sx={{ width: '400px', mr: '10px' }}>
        <CardContent>
          <Grid container>
            <CardCustomItem label="Código" value={controls.foundCode} />
            <CardCustomItem label="Nombre" value={controls.foundName} />
            <CardCustomItem
              label="Últ. versión ZCOR"
              value={
                latestZcorVersion
                  ? `${latestZcorVersion.versionLabel} (${formatDateSlash(
                      latestZcorVersion.versionDate,
                    )})${latestZcorVersion.locked ? ' · bloqueada, usada en cotización' : ''}`
                  : 'Sin versiones guardadas'
              }
            />
            <CardCustomItem label="Base ZCOR" value={describeZcorBase(zcorBase)} />
          </Grid>
        </CardContent>
      </Card>

      <Grid item>
        <ButtonWithLoader
          buttonId="save-zcor-version"
          variant="contained"
          disabled={!controls.zcorHasChanges}
          onClick={onSaveZcor}
          sx={{ mr: '20px' }}>
          {isEditing ? `Guardar cambios en ${zcorBase.versionLabel}` : 'Guardar versión nueva'}
        </ButtonWithLoader>
        <SelectCurrency currencyCode={currencyCode} setCurrencyCode={setCurrencyCode} />
      </Grid>
    </Grid>
  );
};

export default FormulaResultsCard;
